<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'containerComponents.partnerSelection.dialog.selectPartner' | translate }}
  </h1>
  <div mat-dialog-content>
    <div [hidden]="noPartnersExist()">
      <ui-list-filter
        [filtersConfig]="filterConfig"
        (filtersChange)="fetchListBySearchCriteria($event)"
      ></ui-list-filter>
      <mat-table [dataSource]="dataSource" noDataTableMessage>
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null; addOrRemoveRow(row, $event.checked)"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.name' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type1">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.type1' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.extIds[findType1Index(element.extIds)]?.type | partnerTypePipe }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id1">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.id1' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.extIds[type1Index]?.id }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="type2">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.type2' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.extIds[findType2Index(element.extIds)]?.type | partnerTypePipe }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id2">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.id2' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.extIds[type2Index]?.id }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.selected]="selection.isSelected(row)"
          (click)="selection.toggle(row); addOrRemoveRow(row, selection.isSelected(row))"
        ></mat-row>
      </mat-table>

      <mat-paginator #paginator> </mat-paginator>
    </div>

    <div *ngIf="noPartnersExist() && (partnerListFacade.loaded$ | async) && !(loadingFacade.loading$ | async)">
      {{ 'administration.partner.list.noItems' | translate }}
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      *ngIf="!noPartnersExist() && !(loadingFacade.loading$ | async); else createPartnerTemplate"
      [action]="buttonAction.Save"
      [disabled]="isFormUnchanged(initialPartnerList, updatedPartnerList())"
      [type]="buttonType.Primary"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>

<ng-template #createPartnerTemplate>
  <button
    mat-raised-button
    routerLink="/dashboard/administration/partners"
    testId="create-button-link"
    (click)="closeDialog()"
  >
    {{ 'common.button.goToPartners' | translate }}
  </button>
</ng-template>
